module["exports"] = [
  "#{Name.last_name} #{suffix}",
  "#{Name.last_name}-#{Name.last_name}",
  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/company/name.js
// module id = 615
// module chunks = 0